module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Underworld-Awakening.d408665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Underworld-Awakening.jpg
// module id = cUwp
// module chunks = 0